import { axiosClient } from '@src/api/apiClient/axiosClient';

export const tenantLogoutApiClient = {
  logout: async () => {
    await axiosClient.post('/tenant/auth/logout', {});
  },
};
